import { render, staticRenderFns } from "./addressModal.vue?vue&type=template&id=5f5d80ef&scoped=true&"
import script from "./addressModal.vue?vue&type=script&lang=js&"
export * from "./addressModal.vue?vue&type=script&lang=js&"
import style0 from "./addressModal.vue?vue&type=style&index=0&id=5f5d80ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d80ef",
  null
  
)

export default component.exports